import { useState, useCallback } from "react";
import { useAuthenticatedFetchWithWorkspace } from "../../Keycloak/useAuthenticatedFetchWithWorkspace";

interface DeleteCustomersListItem {
    list_id: string | number;
    is_email_list: string;
    is_cell_phone_list: string;
    is_wallet_list: string;
    is_card_list: string;
    is_personid_list: string;
}

interface DeleteCustomersListResponse {
    success?: boolean;
    message?: string;
    deletedCount?: number;
}

const useDeleteCustomersList = () => {
    const { authFetch } = useAuthenticatedFetchWithWorkspace();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>("");
    const [data, setData] = useState<DeleteCustomersListResponse | null>(null);

    const deleteCustomersList = useCallback(async (items: DeleteCustomersListItem[]): Promise<DeleteCustomersListResponse | null> => {
        setLoading(true);
        setError("");
        setData(null);

        try {
            const result: DeleteCustomersListResponse = await authFetch("/deleteCustomersList", {
                method: "DELETE",
                body: JSON.stringify(items),
            });

            setData(result);
            return result;
        } catch (err: unknown) {
            if (err instanceof Error) {
                setError(err.message);
            } else {
                setError("An unknown error occurred");
            }
            return null;
        } finally {
            setLoading(false);
        }
    }, [authFetch]);

    return { deleteCustomersList, loading, error, data };
};

export default useDeleteCustomersList;
